import React, { useState, createContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import RecruitmentRegisterTemplate from "./components/templates/RecruitmentRegisterTemplate";

export const recruitmentRegistrationContext = createContext({});

export default function RecruitmentRegistrationPage() {
  const location = useLocation();

  const defaultMailSubject = location.state?.mailSubject
    ? location.state.mailSubject.replace(/\r\n/g, "\n")
    : "";

  const defaultMailBody = location.state?.mailBody
    ? location.state.mailBody.replace(/\r\n/g, "\n")
    : `■案件概要\n\n■開発環境\n\n■必須スキル\n\n■尚可スキル\n\n■求める人物像\n\n■想定単価\n\n■精算幅\n\n■開始予定時期・期間\n\n■就業場所・リモートワークの有無\n\n■打合せ回数\n\n■募集人数\n\n■備考`;

  const [mailSubject, setMailSubject] = useState(defaultMailSubject);
  const [mailBody, setMailBody] = useState(defaultMailBody);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectType, setProjectType] = useState(null);
  const [requiredSkill, setRequiredSkill] = useState("");

  const contextValues = useMemo(
    () => ({
      defaultMailSubject,
      defaultMailBody,
      isModalOpen,
      setIsModalOpen,
      mailBody,
      setMailBody,
      mailSubject,
      setMailSubject,
      projectType,
      setProjectType,
      requiredSkill,
      setRequiredSkill,
    }),
    [
      defaultMailSubject,
      defaultMailBody,
      isModalOpen,
      mailBody,
      mailSubject,
      projectType,
      requiredSkill,
    ]
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <recruitmentRegistrationContext.Provider value={contextValues}>
          <RecruitmentRegisterTemplate />
        </recruitmentRegistrationContext.Provider>
      </Grid>
    </Grid>
  );
}